import {
  YELP_REQUEST,
  YELP_SUCCESS,
  YELP_FAILURE,
  SATE_LIST_REQUEST,
  SATE_LIST_SUCCESS,
  SATE_LIST_FAILURE,
  COMPANY_LIST_REQUEST,
  COMPANY_LIST_SUCCESS,
  COMPANY_LIST_FAILURE,
  GOOGLE_REVIEW_REQUEST,
  GOOGLE_REVIEW_SUCCESS,
  GOOGLE_REVIEW_FAILURE,
  UPDATE_RATING_REQUEST,
  UPDATE_RATING_SUCCESS,
  UPDATE_RATING_FAILURE
} from './constants';
import { isEmpty } from 'lodash';

let initialState = {
  yelpInfo: {},
  yelpMessageType: '',
  stateList: [],
  companyList: [],
  googlePlaceIdInfo: {},
  googleMessageType: '',
  yelpUpdating: false,
  googlePlaceUpdating: false,
  stateListLoading: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case YELP_REQUEST:
      return { ...state, yelpUpdating: true };
    case YELP_SUCCESS:
      return { ...state, yelpUpdating: false, yelpInfo: action.yelpInfo, yelpMessageType: 'success' };
    case YELP_FAILURE:
      return { ...state, yelpUpdating: false, yelpMessageType: 'error' };
    case GOOGLE_REVIEW_REQUEST:
      return { ...state, googlePlaceUpdating: true };
    case GOOGLE_REVIEW_SUCCESS:
      let googlePlaceIdInfo = {};
      if (!isEmpty(action.googlePlaceIdInfo)) {
        const { name, rating, user_ratings_total } = action.googlePlaceIdInfo;
        googlePlaceIdInfo = {
          name,
          rating,
          review_count: user_ratings_total,
          place_id: action.placeId
        };
      }
      return {
        ...state,
        googlePlaceIdInfo,
        googleMessageType: !isEmpty(action.googlePlaceIdInfo) ? 'success' : 'error',
        googlePlaceUpdating: false
      };
    case GOOGLE_REVIEW_FAILURE:
      return { ...state, googlePlaceUpdating: false, googleMessageType: 'error' };
    case SATE_LIST_REQUEST:
      return { ...state, stateListLoading: true };
    case SATE_LIST_SUCCESS:
      return { ...state, stateList: action.stateList, stateListLoading: false };
    case SATE_LIST_FAILURE:
      return { ...state, stateList: action.stateList, stateListLoading: false };
    case COMPANY_LIST_REQUEST:
      return { ...state };
    case COMPANY_LIST_SUCCESS:
      return { ...state, companyList: action.companyList };
    case COMPANY_LIST_FAILURE:
      return { ...state, companyList: action.companyList };
    case UPDATE_RATING_REQUEST:
      return { ...state };
    case UPDATE_RATING_SUCCESS:
      return {
        ...state,
        yelpUpdating: false,
        googlePlaceUpdating: false
      };
    case UPDATE_RATING_FAILURE:
      return {
        ...state,
        yelpUpdating: false,
        googlePlaceUpdating: false
      };
    default:
      return state;
  }
}

export default reducer;
